import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SharedFooter } from '@pigeons/shared-footer';
import LanguageSwitcher from '../LanguageSwitcher';
import IssueReportModal from '../reports/IssueReportModal';
import { get_website_base_url } from '../../lib/site_config';
import { ReactComponent as FacebookIcon } from '../../assets/images/reseaux/Facebook.svg';
// import { ReactComponent as TwitterIcon } from '../../assets/images/reseaux/Twitter.svg';
import { ReactComponent as LinkedinIcon } from '../../assets/images/reseaux/Linkedin.svg';
import { ReactComponent as InstagramIcon } from '../../assets/images/reseaux/Instagram.svg';

export default function Footer() {
  const { t } = useTranslation(['common', 'reports']);
  const [show_issue_modal, set_show_issue_modal] = useState(false);
  const website_base_url = get_website_base_url();

  return (
    <>
      <SharedFooter
        app_base_url=""
        home_href="/"
        logo_src={`${website_base_url}/assets/images/pigeons_logotype.svg`}
        logo_alt="Pigeons"
        logo_width={179}
        logo_height={36}
        year={String(new Date().getFullYear())}
        socials={[
          {
            id: 'facebook',
            href: 'https://www.facebook.com/nouspigeons.ca',
            icon_node: <FacebookIcon className="h-7 w-7" aria-label="facebook" />,
          },
          // {
          //   id: 'twitter',
          //   href: 'https://twitter.com/nouspigeons',
          //   icon_node: <TwitterIcon className="h-7 w-7" aria-label="twitter" />,
          // },
          {
            id: 'linkedin',
            href: 'https://www.linkedin.com/company/nouspigeons',
            icon_node: <LinkedinIcon className="h-7 w-7" aria-label="linkedin" />,
          },
          {
            id: 'instagram',
            href: 'https://www.instagram.com/p/DXcjbUBFW5p',
            icon_node: <InstagramIcon className="h-7 w-7" aria-label="instagram" />,
          },
        ]}
        labels={{
          freelancer: t('footer.freelancer', {
            ns: 'common',
            defaultValue: t('navigation.freelancer', { ns: 'common' }),
          }),
          recruiter: t('footer.recruiter', {
            ns: 'common',
            defaultValue: t('navigation.client', { ns: 'common' }),
          }),
          community: t('footer.community', { ns: 'common', defaultValue: 'Community' }),
          help: t('footer.help', {
            ns: 'common',
            defaultValue: t('navigation.help', { ns: 'common' }),
          }),
          findProject: t('footer.findProject', {
            ns: 'common',
            defaultValue: t('navigation.findProject', { ns: 'common' }),
          }),
          signup: t('footer.signup', {
            ns: 'common',
            defaultValue: t('navigation.signUp', { ns: 'common' }),
          }),
          findFreelancer: t('footer.findFreelancer', {
            ns: 'common',
            defaultValue: t('navigation.findFreelancer', { ns: 'common' }),
          }),
          publishProject: t('footer.publishProject', {
            ns: 'common',
            defaultValue: t('navigation.postProject', { ns: 'common' }),
          }),
          blog: t('footer.blog', { ns: 'common', defaultValue: 'Blog' }),
          aboutPigeons: t('footer.aboutPigeons', { ns: 'common', defaultValue: 'About Pigeons' }),
          terms: t('footer.terms', {
            ns: 'common',
            defaultValue: t('footer.termsOfUse', { ns: 'common' }),
          }),
          privacy: t('footer.privacy', {
            ns: 'common',
            defaultValue: t('footer.privacyPolicy', { ns: 'common' }),
          }),
          faq: t('footer.faq', {
            ns: 'common',
            defaultValue: t('navigation.faq', { ns: 'common' }),
          }),
          contactUs: t('footer.contactUs', {
            ns: 'common',
            defaultValue: t('navigation.contact', { ns: 'common' }),
          }),
          newsletterTitle: t('footer.newsletterTitle', {
            ns: 'common',
            defaultValue: t('newsletter.title', { ns: 'common' }),
          }),
          emailAria: t('footer.emailAria', {
            ns: 'common',
            defaultValue: t('newsletter.placeholder', { ns: 'common' }),
          }),
          emailPlaceholder: t('footer.emailPlaceholder', {
            ns: 'common',
            defaultValue: t('newsletter.placeholder', { ns: 'common' }),
          }),
          copyright: t('footer.copyright', { ns: 'common', defaultValue: '© {year} Pigeons' }),
        }}
        locale_switcher={<LanguageSwitcher className="text-[16.5px] text-secondary/80" />}
        issue_report={
          <button
            type="button"
            className="transition-colors hover:text-secondary"
            onClick={() => set_show_issue_modal(true)}
          >
            {t('issue.footer_link', { ns: 'reports' })}
          </button>
        }
        render_internal_link={({ href, hash, class_name, children }) => {
          const resolved_href = `${website_base_url}${href}${hash ? `#${hash}` : ''}`;
          return (
            <a href={resolved_href} className={class_name}>
              {children}
            </a>
          );
        }}
      />
      {show_issue_modal && <IssueReportModal onClose={() => set_show_issue_modal(false)} />}
    </>
  );
}
